/* RESPONSIBLE TEAM: team-actions */
import Model, { attr, hasMany } from '@ember-data/model';
import type Action from './action';

export default class McpActions extends Model {
  @attr('string') declare mcp_server_id: string | null;
  @attr('string') declare mcp_server_name: string | null;

  @hasMany('workflow-connector/action', { async: false })
  declare actions: Action[];
}
